/* eslint-disable @typescript-eslint/no-explicit-any */
import moment from "moment";

const inUtc = (date: string) => {
  const localDate = moment(date, "YYYY-MM-DD").toDate();
  return moment(localDate).utc().toISOString();
};

const getEpochTime = (date: Date | string) => {
  const epochTime = moment(date).utc().unix();
  return epochTime;
};

const getEpocinMilliseconds = (date: Date | string) => {
  // Handle DD-MM-YYYY format explicitly
  if (typeof date === "string" && date.match(/^\d{2}-\d{2}-\d{4}$/)) {
    const [day, month, year] = date.split("-").map(Number);
    // Month is 0-indexed in Date constructor
    const parsedDate = new Date(year, month - 1, day);
    return moment(parsedDate).utc().valueOf();
  }
  const epochTime = moment(date).utc().valueOf();
  return epochTime;
};

const getUnixTime = (date: any) => {
  const dateInMilliseconds = date > 1e10 ? date : date * 1000;
  // const date1 = new Date(dateInMilliseconds);
  const formattedDate = moment.utc(dateInMilliseconds).format("DD-MM-YYYY");
  return formattedDate;
};
const getFormatDate = (date: any) => {
  const formattedDate = moment(date).format("DD-MM-YYYY");
  return formattedDate;
};

const epocToDate = (epoch: number) => {
  const date = moment.utc(epoch).format("DD-MM-YYYY");
  return date;
};

export {
  inUtc,
  getEpochTime,
  getUnixTime,
  getFormatDate,
  epocToDate,
  getEpocinMilliseconds,
};
